import { render, staticRenderFns } from "./wanjiegengduo.vue?vue&type=template&id=fe127e0a&scoped=true"
import script from "./wanjiegengduo.vue?vue&type=script&lang=js"
export * from "./wanjiegengduo.vue?vue&type=script&lang=js"
import style0 from "./wanjiegengduo.vue?vue&type=style&index=0&id=fe127e0a&prod&lang=css"
import style1 from "./wanjiegengduo.vue?vue&type=style&index=1&id=fe127e0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe127e0a",
  null
  
)

export default component.exports